module.exports = __webpack_public_path__ + "img/30.fixed_stainless_steel.50e13c00.svg";